import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const DEFAULT_SANITY_PROJECT_ID = '75d0ieyb';
export const DEFAULT_SANITY_DATASET = 'production';

export const projectId = process.env.REACT_APP_SANITY_PROJECT_ID || DEFAULT_SANITY_PROJECT_ID;
export const dataset = process.env.REACT_APP_SANITY_DATASET || DEFAULT_SANITY_DATASET;
export const hasSanityConfig = Boolean(projectId && dataset);

export const sanity = createClient({
  projectId,
  dataset,
  useCdn: false,
  apiVersion: '2025-01-01',
});

const builder = imageUrlBuilder(sanity);

export function urlFor(imageSource) {
  return builder.image(imageSource);
}
